/*@ngInject*/
const UIShowHiddenFieldDetailsModalDirective = function (formMediator, modalUtil) {

    let linkFunction = function ($scope, $elm, $attr) {

        let element = $($elm),
            formId = $scope.formId,
            formData = {},
            hiddenFieldList = [],
            pressKey = 0,
            sectionList = [],
            rowDetailObj = {};

        function collectHiddenFields(formData, hiddenFieldList) {
            if (!_.isNil(formData.sectionList)) {
                _.each(formData.sectionList, function (section) {
                    collectHiddenFields(section, hiddenFieldList);
                });
            }
            if (!_.isNil(formData.rowList)) {
                _.each(formData.rowList, function (row) {
                    collectHiddenFields(row, hiddenFieldList);
                });
            }
            if (!_.isNil(formData.fieldStructureList)) {
                _.each(formData.fieldStructureList, function (rowDetail) {
                    if (!_.isNil(rowDetail)) {
                        if (rowDetail.dynamicProperties.hidden === true) {
                            rowDetailObj = {};
                            rowDetailObj.name = rowDetail.uiField.fieldTemplate.variableName;
                            if (!_.isNil(rowDetail.fieldModel)) {
                                rowDetailObj.id = rowDetail.fieldModel.id;
                                rowDetailObj.value = rowDetail.fieldModel.value;
                            } else {
                                rowDetailObj.value = '';
                            }
                            hiddenFieldList.push(rowDetailObj);
                        }
                    }
                });
            }
        }

        function showHiddenFieldDetailsModal(event) {
            // statement will execute if the key combination is "SHIFT+1+Click"
            if (event.shiftKey && (pressKey === 49)) {
                formData = formMediator.getFormStructure($scope.formId);
                hiddenFieldList = [];
                collectHiddenFields(formData, hiddenFieldList);
                modalUtil.showHiddenFieldDetails(hiddenFieldList);
            }
        }

        $(document).bind('keydown', onKeyDown);

        function onKeyDown(event) {
            pressKey = event.keyCode;
        }

        element.bind('click', showHiddenFieldDetailsModal);

        $scope.$on('$destroy', function () {
            element.unbind('click', showHiddenFieldDetailsModal);
            $(document).unbind('keydown', onKeyDown);
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiShowHiddenFieldDetailsModal', UIShowHiddenFieldDetailsModalDirective);
